import React from 'react';
import { SettingsHeader } from '../Settings';
import './About.scss';
import PropTypes from 'prop-types';

const AboutDetails = props => {
    const { backToAbout } = props;
    return (
        <div className="setting-container">
            <div>
                <div className="settinglist">
                    <SettingsHeader handleBackFromSetting={backToAbout} label={'About Us'} />
                    <div className="setting-list-ul Details">
                        <div className="content-block">
                            <p className="content">
                                Welcome to EN Connect – a next-generation chat platform designed to make communication
                                simple, secure, and truly personal. In a world where conversations fuel connections, EN
                                Connect goes beyond basic texting, creating a space where you can share moments, ideas,
                                and experiences effortlessly. Our vision is to provide a messaging tool that is fast,
                                private, and beautifully designed for every kind of connection — whether it’s a quick
                                note to a friend, a heartfelt conversation with family, or a productive chat with your
                                team. With advanced security, a sleek design, and a host of intuitive features, EN
                                Connect is your trusted companion for all things messaging. EN Connect is a ready-to-go
                                messaging solution for building enterprise-grade real-time chat IM applications that
                                meet various degrees of requirements like team discussion, data sharing, task delegation
                                and information handling on the go.
                            </p>
                        </div>
                        <div className="content-block">
                            <h3 className="subheading">Contact Us</h3>
                            <p className="content">To have a detailed interaction with our experts</p>
                        </div>
                        <div className="content-block">
                            <h3 className="subheading">FAQ</h3>
                            <p className="content">
                                Kindly checkout FAQ section for doubts regarding EN Connect. We might have already
                                answered your question.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutDetails;

AboutDetails.propTypes = {
    backToAbout: PropTypes.func,
};
